import React, { Fragment, useState } from "react";

/**
 * Components
 */
import GuyThumbsUpPath from "../../assets/svg/guy_thumbsup.svg";
import BaseButton from "../../components/base-button/base-button";
import { faCircleNotch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import API from "../../utils/api";
import useModal from "../../hooks/use-modal";
import { calculatePaymentPlan } from "../../utils/paymentplan";

const ModalAlertOffer = (props) => {
  const { closeModal } = useModal();
  const { alert, startPlan, notToday } = props.modalProps;
  const [loaded, setLoaded] = useState(false);
  const [account, setAccount] = useState({});
  const [alertDetails, setAlertDetails] = useState({});
  const [paymentPlan, setPaymentPlan] = useState({});

  const _fetchAccounts = async () => {
    try {
      let accountId;
      alert.params.forEach((al) => {
        if (al.name === "account_id") accountId = al.value;
      });

      const response = await API.get("/accounts");
      if (response.data.account && response.data.account.length > 0) {
        for (let i = 0; i < response.data.account.length; i++) {
          if (response.data.account[i].id === accountId) {
            setAccount(response.data.account[i]);
            await fetchPaymentPlans(
              response.data.account[i].creditor.id,
              response.data.account[i]
            );
            setLoaded(true);
          }
        }
      }
    } catch (e) {}
  };

  const fetchPaymentPlans = async (creditor, acc) => {
    console.log('[modal-alert-offer] fetchPaymentPlans called, creditor:', creditor, 'acc:', acc);
    try {
      console.log('[modal-alert-offer] Making API call to /payment_plans/config');
      const response = await API.get("/accounts/" + acc.id + "/payment_plans/config");
      if (response.data) {
        const foundPlanConfig = {};
        const cur_bal = Number(acc.balance_current);
        
        if (alert.type === "repayment_plan") {
          // Check if payment plans are eligible and use max_months
          if (response.data.eligible && response.data.max_months) {
            const months = Number(alertDetails["months"]) || response.data.max_months;
            foundPlanConfig.config = {
              amount: cur_bal,
              price: cur_bal / months,
              text: `${months} months`,
            };
          }
        } else if (alert.type === "increase_payment_plan") {
          // Handle increase payment plan logic based on new config
          if (response.data.eligible && response.data.max_months) {
            const months = response.data.max_months;
            foundPlanConfig.config = {
              amount: cur_bal,
              price: cur_bal / months,
              text: `${months} months`,
            };
          }
        }
        
        console.log(foundPlanConfig);
        setPaymentPlan(foundPlanConfig);
      } else {
      }
    } catch (e) {
      console.log(e);
    }
  };

  const _startPlan = async () => {
    try {
      await API.put(`/alerts/${alert.id}/dismiss`);
      startPlan({ account: account.id, plan: paymentPlan });
    } catch (e) {
      console.log(e);
    }
  };

  const _increasePlan = async () => {
    try {
      startPlan({
        account: account,
        amount: Number(alertDetails["amount"]),
      });
      await API.put(`/alerts/${alert.id}/dismiss`);
    } catch (e) {
      console.log(e);
    }
  };

  const _closeModal = async () => {
    try {
      await API.put(`/alerts/${alert.id}/dismiss`);
      notToday();
    } catch (e) {
      console.log(e);
    }
    closeModal();
  };

  React.useEffect(() => {
    _fetchAccounts();
    if (alert.params && alert.params.length > 0) {
      const newAlertDetails = {};
      for (const param of alert.params) {
        newAlertDetails[param.name] = param.value;
      }
      setAlertDetails(newAlertDetails);
    }
  }, []);

  return (
    <Fragment>
      <div style={{ textAlign: "center" }}>
        {!loaded && (
          <FontAwesomeIcon
            icon={faCircleNotch}
            spin
            className="fast-spin"
            color="#ccc"
            size="2x"
            style={{ opacity: "0.5", marginTop: "10px" }}
          />
        )}
        {loaded && alert.type === "repayment_plan" && (
          <>
            <img
              src={GuyThumbsUpPath}
              width={200}
              alt={"picture of a guy holding a puzzle"}
            />
            <h1
              style={{
                color: "#272643",
                fontWeight: "lighter",
                marginTop: "10px",
                marginBottom: "10px",
              }}
            >
              Your Custom Repayment Plan
            </h1>
            <p>
              Based on your provided information, a repayment plan of $
              {alertDetails["amount"]}/mo for {alertDetails["months"]} months
              may be a great option!
            </p>
            <BaseButton
              type="button"
              className="btn--primary"
              style={{ marginTop: "30px" }}
              onClick={() => _startPlan()}
            >
              I want to start the plan
            </BaseButton>
            <p style={{ marginTop: "10px" }} onClick={() => _closeModal()}>
              Not today
            </p>
          </>
        )}
        {loaded && alert.type === "increase_payment_plan" && (
          <>
            <img
              src={GuyThumbsUpPath}
              width={200}
              alt={"picture of a guy holding a puzzle"}
            />
            <h1
              style={{
                color: "#272643",
                fontWeight: "lighter",
                marginTop: "10px",
                marginBottom: "10px",
              }}
            >
              Time to increase your payment?
            </h1>
            <p style={{ marginBottom: "20px" }}>
              Have you considered increasing your monthly payment? Any increase
              in your payment will reduce the amount of time it takes to pay off
              the account.
            </p>
            <div>Account: {account.name}</div>
            <div>Current monthly payment: ${alertDetails["amount"]}</div>
            <BaseButton
              type="button"
              className="btn--primary"
              style={{ marginTop: "30px" }}
              onClick={() => _increasePlan()}
            >
              I want to increase my payment
            </BaseButton>
            <p style={{ marginTop: "10px" }} onClick={() => _closeModal()}>
              Not today
            </p>
          </>
        )}
      </div>
    </Fragment>
  );
};

export default ModalAlertOffer;
